/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import config from 'linced-admin/config/environment';
import { service } from '@ember/service';
import ConnectionStatus from '@linc-technologies/linced-common/enums/connection-status';
import { action } from '@ember/object';

export default class SyncProgressManager extends Component {
  ConnectionStatus = ConnectionStatus;

  // services
  @service
  fetch;

  @service
  store;

  @service
  toaster;

  // params
  schoolId = '';

  lastSyncTime = 'last sync';
  status = null;

  // variables
  @tracked
  dialogueOpen = false;

  @tracked
  openLatestSync = false;
  @tracked
  fullSync = false;
  @tracked
  processingSync = false;

  performSync() {
    this.processingSync = true;
    let url = `${config.APP.apiHost}/providers/wonde/${config.APP.apiPath}/sync:start`;
    let params = {
      schoolId: this.schoolId,
      fullSync: this.fullSync,
    };

    this.fetch
      .post(url, { data: JSON.stringify(params) })
      .then(() => {
        setTimeout(() => {
          this.toaster.success(
            `${this.fullSync ? 'Full' : 'Partial'} sync started`,
          );
          this.dialogueOpen = true;
          this.openLatestSync = true;
          this.fullSync = false;
          this.processingSync = false;
        }, 1000);
      })
      .catch(() => {
        this.toaster.error(
          `Error creating new ${
            this.fullSync ? 'full' : 'partial'
          } sync: Please wait for all current syncs to resolve before starting a new one`,
        );
        this.fullSync = false;
        this.processingSync = false;
      });
  }

  @action
  triggerPartialSync() {
    this.fullSync = false;
    this.performSync();
  }

  @action
  triggerFullSync() {
    this.fullSync = true;
    this.performSync();
  }

  @action
  toggleDialogue() {
    this.dialogueOpen = !this.dialogueOpen;
    if (this.openLatestSync) {
      this.openLatestSync = false;
    }
  }
}
